import React from "react";
import { useI18n } from "../lib/i18n";
import { Globe } from "lucide-react";
import {
    DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger,
} from "./ui/dropdown-menu";

export default function LanguageSwitcher() {
    const { lang, setLang, languages } = useI18n();
    const current = languages.find((l) => l.code === lang) || languages[0];
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild>
                <button className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm text-[var(--rl-text-2)] hover:bg-[var(--rl-cream)]"
                        data-testid="language-switcher-trigger" aria-label="Change language">
                    <Globe className="w-3.5 h-3.5" />
                    <span className="hidden sm:inline">{current.flag} {current.name}</span>
                    <span className="sm:hidden">{current.flag}</span>
                </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="bg-[var(--rl-surface)] min-w-[160px]" data-testid="language-switcher-menu">
                {languages.map((l) => (
                    <DropdownMenuItem key={l.code} onSelect={() => setLang(l.code)}
                                      className={`cursor-pointer ${lang === l.code ? "bg-[var(--rl-cream)]" : ""}`}
                                      data-testid={`lang-option-${l.code}`}>
                        <span className="mr-2 text-base">{l.flag}</span>{l.name}
                    </DropdownMenuItem>
                ))}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
